import { Theme } from '@just-in-types';
import styled from 'react-emotion';
import { connect } from 'react-redux';
import { IState } from '../store/reducers';

interface IInputOwnProps {
  fontSize?: string;
  focused?: boolean;
  margin?: string;
  width?: string;
  touched?: boolean;
  valid?: boolean;
}
interface IInputStateProps {
  colors: Theme.Colors;
}

type InputProps = IInputOwnProps & IInputStateProps;

const Input = styled('input')`
  &[type='number']::-webkit-outer-spin-button,
  &[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  font-size: ${(props: InputProps) => props.fontSize};
  border-radius: 12px;
  border: 2px solid black;
  box-shadow: ${({ colors, focused, touched, valid }: InputProps) => {
    let shadow = '1px 2px 1px 1px black';

    if (focused) {
      shadow = shadow.concat(
        `, 1px 2px 0 6px ${colors.primary}, 1px 2px 0 5px white`,
      );
    }

    if (valid) {
      return shadow.concat(`, inset 0 0 3px 4px ${colors.success}`);
    } else {
      if (touched) {
        return shadow.concat(`, inset 0 0 3px 4px ${colors.error}`);
      }
    }
    return shadow;
  }};
  outline: none;
  padding: 0.5rem;
  margin-right: 1rem;
  margin-bottom: 1rem;
  width: ${(props: InputProps) => props.width};
  text-align: center;
  transition: box-shadow 250ms;

  ${(props: InputProps) => props.margin && `margin: ${props.margin};`};
`;

Input.displayName = 'Input';

const mapStateToProps = ({ theme: { colors } }: IState) => ({ colors });

export default connect(mapStateToProps)(Input);



// WEBPACK FOOTER //
// ./src/components/Input.ts